import React, { useEffect, useState } from 'react'
import {
  Breadcrumb,
  Layout,
  Menu,
  theme,
  Button,
  Input,
  Select,
  Upload,
  message,
  Table,
  Modal,
  Spin,
} from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import Navbar from '../../../../components/Navbar'
import IncentivesOverviewCard from './IncentivesOverviewCard'

import axiosInstance from '../../../../utils/axiosInstance'

const { Header, Content, Footer, Sider } = Layout
const { Option } = Select
function IncentivesForm() {
  const [leadInfo, setLeadInfo] = useState(null)
  const [loading, setLoading] = useState(false)
  const [salaryEntries, setsalaryEntries] = useState([])
  const auth = useSelector((state) => state.auth)

  const columns = [
    {
      title: 'SL',
      // dataIndex: 'serial',
      render: (text, record, index) => <span>{index + 1}</span>,
      key: 'serial',
      align: 'center',
    },
    {
      title: 'CAMPAIGN NAME',
      dataIndex: 'campaignName',
      key: 'campaignName',
      align: 'center',
    },
    {
      title: 'CAMPAIGN FROM',
      dataIndex: 'timeLineFrom',
      key: 'timeLineFrom',
      align: 'center',
    },
    {
      title: 'CAMPAIGN TILL',
      dataIndex: 'timeLineTo',
      key: 'timeLineTo',
      align: 'center',
    },
    {
      title: 'RECEIVED DATE',
      dataIndex: 'receivedDate',
      key: 'receivedDate',
      align: 'center',
    },
    {
      title: 'MEDIUM',
      dataIndex: 'medium',
      key: 'medium',
      align: 'center',
    },
    {
      title: 'ACHIEVEMENT %',
      dataIndex: 'achievement',
      key: 'achievement',
      align: 'center',
    },
  ]

  const getIncentivesOfUser = async () => {
    // setLoading(true)

    let pathString = `/cm/getIncentivesOfUser`

    try {
      try {
        const response = await axiosInstance.get(pathString)
        console.log(response.data)

        setsalaryEntries(response.data.results)
        setLoading(false)
      } catch (error) {
        console.error('Request Error:', error)
      }
    } catch (error) {
      console.error('Request Error:', error)
      // You can handle the error here
      // showError(true)
      setLoading(false)
    }
  }

  useEffect(() => {
    getIncentivesOfUser()
  }, [])

  return (
    <div>
      <Navbar />
      <Layout
        style={{
          minHeight: '100vh',
        }}
      >
        <Content
          style={{
            // margin: '0 16px',
            padding: '30px 16px',
            backgroundColor: '#fff',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <div style={{}}>
              <IncentivesOverviewCard leadInfo={leadInfo} />
            </div>
          </div>
          <h2 style={{ color: '#275058', textDecoration: 'underline' }}>
            SALARY SUMMARY
          </h2>
          <Table
            dataSource={salaryEntries}
            columns={columns.map((each) => ({
              ...each,
              className: 'maxWidthCell',
            }))}
            bordered
            pagination={false}
          />
        </Content>
      </Layout>
    </div>
  )
}

export default IncentivesForm
